var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notificationStatus",style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr'})},[_c('feather-icon',{class:{ readNotification: _vm.isRead },attrs:{"icon":"CheckIcon","svgClasses":"h-5 w-5 mr-4 hover:text-primary cursor-pointer"},on:{"click":_vm.readNotification}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }